var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWidgetFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 182 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 14913",
    transform: "translate(437.234 13.662)",
    fill: "#185edf",
    stroke: "#707070",
    d: "M0 0h24v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1050",
    transform: "translate(-437.234 -13.662)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 14914",
    fill: "none",
    d: "M437.234 13.662h24v24h-24z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20399",
    d: "M450.734 35.662h-.35l-3.5-.75a1.55 1.55 0 0 1-1.15-1.5v-6.25l-6-5.6a1.3 1.3 0 0 1-.5-1.1v-3.3a1.5 1.5 0 0 1 1.5-1.5h17a1.5 1.5 0 0 1 1.5 1.5v3.8a1.4 1.4 0 0 1-.55 1.15l-6.45 5.1v6.95a1.521 1.521 0 0 1-1.5 1.5Zm-3-2.7 2.5.6v-7.3l7-5.55v-3.05h-16v2.6l6.5 6.05Z",
    fill: "#185edf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetFilter);
export default __webpack_public_path__ + "static/media/WidgetFilter.cb12f32495ffaeb6b93a3346d0fa6bf4.svg";
export { ForwardRef as ReactComponent };